"use client";

import { useLingui } from "@lingui/react/macro";
import { Alert } from "@offstreetparking/design-system/feedback";
import { Button } from "@offstreetparking/design-system/forms";
import { Heading, Text } from "@offstreetparking/design-system/typography";
import { OverlayShell } from "./OverlayShell";

type ParkerSetupPromptProps = {
	isError: boolean;
	onRetry: () => void;
};

export const ParkerSetupPrompt = ({ isError, onRetry }: ParkerSetupPromptProps) => {
	const { t } = useLingui();

	if (isError) {
		return (
			<OverlayShell label={t`Setting up your account`}>
				<Alert
					type="error"
					title={t`Something went wrong. Please try again.`}
					message={t`We had trouble connecting to your account. Please check your connection and try again.`}
				/>
				<Button className="w-full" intent="primary" size="lg" onClick={onRetry}>
					{t`Retry`}
				</Button>
			</OverlayShell>
		);
	}

	return (
		<OverlayShell label={t`Setting up your account`}>
			<Heading As="h1" kind="h1" className="font-bold text-3xl leading-tight sm:text-4xl">
				{t`Setting up your account`}
			</Heading>
			<Text intent="muted">{t`This will only take a moment…`}</Text>
		</OverlayShell>
	);
};
